import { mount } from 'svelte';
import MyEventListview from './templates/MyEventListview.svelte';
import ModifyEvent from './templates/ModifyEvent.svelte';

export const initMyEventList = () => {
  const eventList = document.querySelector('#js-event-list');

  if (!eventList) {
    return;
  }

  mount(MyEventListview, {
    target: eventList,
  });
};

export const initModifyEvent = () => {
  const modifyEvent = document.querySelector('#js-modify-event');

  if (!modifyEvent) {
    return;
  }

  mount(ModifyEvent, {
    target: modifyEvent,
    props: {
      event: window.currentEvent,
    },
  });
};
